module.exports = __webpack_public_path__ + "img/gift4-01-c03-y2.6296fb6f.png";